export enum PayGatePaymentType {
  STANDARD = "STANDARD",
  APPLE_PAY = "APPLE_PAY",
  GOOGLE_PAY = "GOOGLE_PAY",
  TERMINAL = "TERMINAL",
}

export enum PayGatePaymentStatus {
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  DEFERRED = "DEFERRED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
}

export interface PayGatePaymentRetryPermittedAction {
  isAllowed: boolean;
  allowedPayGatePaymentTypes: PayGatePaymentType[] | null;
  retryPaymentAllowedUntil?: string | null;
}

export interface PayGatePaymentPermittedActions {
  paymentRetry: PayGatePaymentRetryPermittedAction;
}

export default interface PayGatePaymentResponse {
  payGatePaymentType: PayGatePaymentType;
  status: PayGatePaymentStatus;
  permittedActions: PayGatePaymentPermittedActions;
}
